import ForbiddenIp from './ForbiddenIp';

export default ForbiddenIp;
